import React from 'react';
import Grid from '@material-ui/core/Grid'
import {AutocompleteInput, LongTextInput, ReferenceInput, required} from 'react-admin';
import {CancelToDateInput} from "./CancelToDateInput";
import {CancelFromDateInput} from "./CancelFromDateInput";


const PurchaseCancelRequestFields = props => (
    <React.Fragment>
        <Grid item xs={12} sm={6}>
            <CancelFromDateInput {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <CancelToDateInput {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <ReferenceInput
                source="kiotConfigId"
                reference="kiotConfigs" {...props} validate={required()}>
                <AutocompleteInput optionText={"name"}/>
            </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={6}>
            <LongTextInput style={{width: '100%'}} multiline={true} rows={3} source="reason"
                           validate={required()} {...props} />
        </Grid>

    </React.Fragment>
)

export default PurchaseCancelRequestFields
